import FlowTutor from './FlowTutor';

function App() {
  return (
    <div className="App">
      <FlowTutor />
    </div>
  );
}

export default App;